"use client";

import { useEffect } from "react";
import Clarity from "@microsoft/clarity";

export default function ClarityAnalytics() {
  useEffect(() => {
    // Only initialize Clarity in production.
    if (process.env.NODE_ENV !== "production") return;
    const projectId =
      process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID?.trim() || "r2xg3jt75q";
    if (!projectId) return;

    Clarity.init(projectId);
  }, []);

  return null;
}
